module.exports = __webpack_public_path__ + "img/13-1_04.f4e2abcd.jpg";